export class User {
  id?: number;
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  isStaff: boolean;
}
